import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';

import type {
    LeaveBuildHubMutation,
    LeaveBuildHubMutationVariables,
} from 'generated/graphql';
import { LeaveBuildHubDocument } from 'generated/graphql';
import invariant from 'tiny-invariant';

export const LEAVE_BUILD_HUB_API_ROUTE = '/remix-api/app/build-hub-leave';

const DEFAULT_FAILED_MESSAGE = 'Failed to leave BuildHub.';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('id'), 'BuildHub ID is required.');

    const variables: LeaveBuildHubMutationVariables = {
        BuildHubID: data.get('id') as string,
    };

    try {
        const { data: result } = await context.client.mutate<
            LeaveBuildHubMutation,
            LeaveBuildHubMutationVariables
        >({
            mutation: LeaveBuildHubDocument,
            variables,
        });

        const validResult = result?.buildHubLeaveProject;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
